import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Applicant } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles } from './index';
import { SubHeading } from '../investors/components';
import { checkAddressField, checkValidationBasedOnDate } from '../../utils/utilityFunctions';
import { useValidationOrConfigHook } from '../../utils/validationOrConfigHook';
import { YesNoMaster } from '../../utils/constant';

export default function ContactDetails({
  applicants = [],
  createdAt,
}: {
  applicants: Partial<Applicant>[];
  createdAt: string;
}): JSX.Element {
  const { kycenablestatus = '' } = useValidationOrConfigHook();
  const shouldkycenable = checkValidationBasedOnDate(createdAt || '', kycenablestatus);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Contact Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ color: 'common.black', letterSpacing: 0.5 + 'px' }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pt={2}
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'E-Mail ID'} description={applicant.email} />
                      <KeyValue
                        title={'Mobile Number'}
                        description={
                          applicant.countryCode
                            ? applicant.countryCode + '-' + applicant.mobile
                            : applicant.mobile
                        }
                      />
                      {applicant.kraMobileNumber && (
                        <KeyValue
                          title={'KRA Mobile Number'}
                          description={applicant.kraMobileNumber}
                        />
                      )}
                      {applicant.kraEmail && (
                        <KeyValue title={'KRA E-Mail ID'} description={applicant.kraEmail} />
                      )}
                      <KeyValue
                        title={'Phone Number (Office)'}
                        description={applicant.phoneNumberoffice}
                      />
                      <KeyValue
                        title={'Phone Number (Residential)'}
                        description={applicant.phoneNumberResidence}
                      />
                      {shouldkycenable && (
                        <KeyValue
                          title={'Address Change Required'}
                          description={YesNoMaster[applicant.addrChangeRequired || '']}
                        />
                      )}
                      {!!applicant?.addresses?.length &&
                        applicant?.addresses.map((address) => (
                          <React.Fragment key={address.id}>
                            <KeyValue
                              title={`${address.address_type} Address`}
                              description={`${checkAddressField(
                                address.address1
                              )}${checkAddressField(address.address2)}${checkAddressField(
                                address.address3
                              )}
                              ${checkAddressField(address.city)}${checkAddressField(
                                address.state
                              )}${checkAddressField(address.country)}${address.pincode}`}
                              sx={{
                                textTransform: 'capitalize',
                              }}
                            />
                          </React.Fragment>
                        ))}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
